// Note: integrated proximusConfig + entityConfig + headers constants
export const HTTP_CONSTANTS = {
    ETAG_HEADER: 'etag',
    CACHE_CONTROL_HEADER: 'cache-control',
    X_APPLICATION_LANGUAGE_HEADER: 'X-Application-Language',
    X_APPLICATION_USER_ID_HEADER: 'x-application-user-id',
    IF_NONE_MATCH_HEADER: 'If-None-Match',
    X_APPLICATION_ENCRYPTION_KEY_HEADER: 'x-application-encryption-key',
    X_CALLER_CHAIN_HEADER: 'x-caller-chain',
    ACCEPT_HEADER: 'Accept',
    CONTENT_TYPE_HEADER: 'Content-Type',
    X_APPLICATION_AUTHORIZATION_HEADER: 'x-application-authorization',
};
export const DATASTRATEGY = {
    /**
     * @deprecated TWO_PHASE_COMMIT will be replaced with CACHE_NETWORK_WITH_ERRORS
     */
    TWO_PHASE_COMMIT: 'TWO_PHASE_COMMIT',
    CACHE_NETWORK_NO_ERRORS: 'CACHE_NETWORK_NO_ERRORS',
    CACHE_NETWORK_WITH_ERRORS: 'CACHE_NETWORK_WITH_ERRORS',
    PROXY_STORAGE: 'PROXY_STORAGE',
    STORAGE_PROXY: 'STORAGE_PROXY',
    STORAGE_ONLY: 'STORAGE_ONLY',
    NONE: 'none',
};
// Note: we still need to know about this storage strategy.. - should this logic be removed?
export const STORAGESTRATEGY = {
    NONE: 'none',
};
